import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import NattoPage from "../pages/natto/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <Home />,
  },
  {
    path: "/services",
    element: <Home />,
  },
  {
    path: "/natto",
    element: <NattoPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;